import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import Dropdown, { DropdownDivider, DropdownItem } from './Dropdown/Dropdown';
import { ReactComponent as EllipsisVertical } from '../../icons/more-vert.svg';
import { ReactComponent as CopyIcon } from '../../icons/copy.svg';
import { ReactComponent as EditIcon } from '../../icons/edit.svg';
import { ReactComponent as DeleteIcon } from '../../icons/xmark-circle.svg';
import { ReactComponent as IntensityIcon } from '../../icons/intensity.svg';

import './Options.scss';
import './PartOptions.scss';

const PartOptions = ({
  part,
  partIndex,
  onPartDuplicate,
  onPartEdit,
  onPartDelete,
  // Given only where the part can be set in the intensity panel
  onPartIntensity,
  onMenuOpenChange,
  showDuplicateToEnd = true,
  showDuplicateToSectionEnd = true,
}) => {
  const { t } = useTranslation();
  const deleteDisabled = part.hasDuplicates;

  return (
    <div className="Options PartOptions">
      <Dropdown
        align="right"
        menuClassName="options-menu"
        trigger={<Icon icon={<EllipsisVertical />} className="options-icon" />}
        onOpenChange={onMenuOpenChange}
      >
        {!part.isDuplicate && (
          <DropdownItem shortcut="d" onClick={(e) => onPartDuplicate(part, e)}>
            <Icon className="options__icon" icon={<CopyIcon />} />
            <span>{t('songForm.partOptions.duplicate')}</span>
          </DropdownItem>
        )}
        {!part.isDuplicate && showDuplicateToEnd && (
          <DropdownItem shortcut="v" onClick={() => onPartDuplicate(part, { atEnd: true })}>
            <Icon className="options__icon" icon={<CopyIcon />} />
            <span>{t('songForm.partOptions.duplicateToEnd')}</span>
          </DropdownItem>
        )}
        {!part.isDuplicate && showDuplicateToSectionEnd && (
          <DropdownItem shortcut="s" onClick={() => onPartDuplicate(part, { atSectionEnd: true })}>
            <Icon className="options__icon" icon={<CopyIcon />} />
            <span>{t('songForm.partOptions.duplicateToSectionEnd')}</span>
          </DropdownItem>
        )}
        <DropdownItem shortcut="e" onClick={() => onPartEdit(part)}>
          <Icon className="options__icon" icon={<EditIcon />} />
          <span>{t('common.edit')}</span>
        </DropdownItem>
        {onPartIntensity && (
          <DropdownItem shortcut="i" onClick={() => onPartIntensity(part)}>
            <Icon className="options__icon" icon={<IntensityIcon />} />
            <span>{t('songForm.partOptions.intensity')}</span>
          </DropdownItem>
        )}
        <DropdownDivider />
        <DropdownItem
          className="options__delete"
          shortcut="r"
          disabled={deleteDisabled}
          title={deleteDisabled ? t('songForm.partOptions.cantRemove') : t('songForm.partOptions.removePart')}
          onClick={() => onPartDelete(part, partIndex)}
        >
          <Icon className="options__icon" icon={<DeleteIcon />} />
          <span>{t('songForm.partOptions.remove')}</span>
        </DropdownItem>
      </Dropdown>
    </div>
  );
};

export default PartOptions;
